import {
  Box,
  Button,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useHotel } from "../context/HotelContext";
import LoadingGif from "../components/LoadingGif";
import { useState, useEffect } from "react";
import { ArrowLeft, } from "lucide-react";

const HotelPayment = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { hotelId } = useParams();
  const isMobile = useMediaQuery("(max-width:950px)");
  const { fetchDraft, hotelData, loading, } = useHotel();

  const rowLabelSx = { fontSize: isMobile ? "12px" : "13px", color: "#999", width: isMobile ? "100%" : "160px", flexShrink: 0 };
  const rowValueSx = { fontWeight: "600", fontSize: isMobile ? "14px" : "16px", color: "#000" };

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#F5F5F5",
  };

  const [billingAddress, setBillingAddress] = useState({
    streetAddress: "",
    unit: "",
    city: "",
    region: "",
    postalCode: "",
  });

  const [payment, setPayment] = useState({
    accountName: "",
    bankName: "",
    branchCode: "",
    lastAccDigit: 0,
  });

  useEffect(() => {
    if (hotelId) {
      fetchDraft(hotelId);
    }
  }, [hotelId, fetchDraft]);

  useEffect(() => {
    if (hotelData.billingAddress) {
      setBillingAddress(hotelData.billingAddress);
    }
    if (hotelData.payment) {
      setPayment({
        accountName: hotelData.payment.accountName || "",
        bankName: hotelData.payment.bankName || "",
        branchCode: hotelData.payment.branchCode || "",
        lastAccDigit: hotelData.payment.lastAccDigit || 0,
      });
    }
  }, [hotelData]);

  const contentStyle = {
    flex: "1 0 auto",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: isMobile ? "100px 20px 60px" : "120px 80px 80px",
    maxWidth: "1600px",
    width: "100%",
  };

  const ReviewRow = ({ labelKey, value }) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "flex-start",
        gap: isMobile ? 0.5 : 2,
        padding: "20px 0",
        borderBottom: "1px solid #E0E0E0",
      }}
    >
      <Typography sx={rowLabelSx}>{t(labelKey)}</Typography>
      <Typography sx={rowValueSx}>{value}</Typography>

    </Box>
  );

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={contentStyle}>
        <Box sx={{ width: isMobile ? "100%" : "60%", mx: "auto", display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
              <Button
                onClick={() => navigate("/hotel/onboarding")}
                sx={{
                  minWidth: "auto",
                  width: isMobile ? "36px" : "44px",
                  height: isMobile ? "36px" : "44px",
                  borderRadius: "50%",
                  backgroundColor: "#31BACD",
                  color: "#fff",
                  padding: 0,
                  alignSelf: isMobile ? "flex-start" : "center",
                  "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                }}
              >
                <ArrowLeft size={isMobile ? 18 : 22} />
              </Button>
              <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 1, alignItems: isMobile ? "flex-start" : "center", }}>
                <Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "20px" : "24px", color: "#000" }}>
                  {t('StepPaymentMethod')}
                </Typography>
              </Box>
            </Box>
            <Button
              sx={{
                backgroundColor: "#FFB60D",
                color: "#fff",
                padding: "10px 12px",
                borderRadius: "6px",
                textTransform: "none",
                fontSize: isMobile ? "12px" : "14px",
                lineHeight: 1,
                "&:hover": { backgroundColor: "#f5cc6d" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "flex-start",
                gap: 1,
                fontWeight: "700",
              }}
              onClick={() => { navigate(`/hotel/${hotelId}/update-payment`); }}>
              <img src="/icons/roomEditingSelected.svg" alt="lock" style={{ width: "20px", height: "auto" }} />
              <span>{t('Update')}</span>
            </Button>
          </Box>

          {loading ? (
            <LoadingGif />
          ) : (
            <Box sx={{ width: "100%" }}>
              <ReviewRow labelKey="AccountNameRowLabel" value={payment.accountName} />
              <ReviewRow labelKey="BankNameRowLabel" value={payment.bankName} />
              <ReviewRow labelKey="BranchCodeRowLabel" value={payment.branchCode} />
              <ReviewRow labelKey="AccountNumberRowLabel" value={`*******${payment.lastAccDigit}`} />
              <ReviewRow labelKey="AddressRowLabel" value={billingAddress.streetAddress} />
            </Box>
          )}
        </Box>
      </div>
      <Footer />
    </div>
  );
};

export default HotelPayment;
